import { useNodesData, Handle, Position } from "@xyflow/react";
import { usePipelineBuilder } from "V2.0/HomePages/Pipelines/PipelineBuilder/PipelineBuilderProvider";
import { validateNodeConfig } from "../NodeConfigure/nodeValidation";
import {
  Node,
  NodeActions,
  NodeBadge,
  NodeBody,
  NodeHeader,
  NodeName,
} from "./Components/Node";
import AddStepAction from "./Components/AddStepAction";
import ConfigureStepAction from "./Components/ConfigureStepAction";
import DeleteStepAction from "./Components/DeleteStepAction";
import { NodeUIRegistry } from "../Models/nodeUIRegistry";
import { NodeType } from "../Models/NodeType";
import { useMemo } from "react";
import NodeExecutionStatusBadge from "./Components/NodeExecutionStatus";
import usePipelineNode from "./Hooks/usePipelineNode";
import { TExternalApiConfig } from "../Models/ExternalApi";

export default ExternalApiNode;

function ExternalApiNode(props) {
  const { id } = props;

  const {
    data,
    onDelete,
    handleAdd,
    isExecuted,
    internalNode,
    isPanelActive,
    isPreviewMode,
    onConfigureNode,
    executedNodeStatus,
  } = usePipelineNode<TExternalApiConfig>(id);

  const {
    label,
    color,
    icon: Icon,
  } = NodeUIRegistry[NodeType.EXTERNAL_API]["default"];

  return (
    <>
      <Handle
        type="target"
        position={Position.Top}
      />
      <Node status={executedNodeStatus}>
        <NodeHeader>
          <NodeBadge
            color={color}
            label={label}
            icon={<Icon className="size-4" />}
          />
          <NodeActions hideActions={isPanelActive}>
            {!isPreviewMode && <AddStepAction onAddStep={handleAdd} />}
            {(!isPreviewMode || isExecuted ) && <ConfigureStepAction
              onConfigureStep={() => onConfigureNode(internalNode)}
            />}
            {!isPreviewMode && (
              <DeleteStepAction onDeleteStep={() => onDelete(internalNode)} />
            )}
          </NodeActions>
        </NodeHeader>
        <NodeBody>
          <NodeName name={data.name} />
          {isExecuted && (
            <NodeExecutionStatusBadge status={executedNodeStatus} />
          )}
        </NodeBody>
      </Node>
      <Handle
        id="default"
        type="source"
        position={Position.Bottom}
      />
    </>
  );
}
